export default defineNuxtRouteMiddleware((to, from) => {
  const localePath = useLocalePath()
  const { access_token } = localStorage.user ? JSON.parse(localStorage.user) : {}

  if (!access_token) {
    return navigateTo(localePath('/'), { redirectCode: 301 })
  }
})
